import { HOME_PATH } from '@/paths';
import { NavLink } from '@make-software/cspr-design';
import LogoImage from '@/assets/logo.png';
import { RouterLink } from '../link';
import styled from 'styled-components';

const StyledNavLink = styled(NavLink)(({ theme }) =>
  theme.withMedia({
    cursor: 'pointer'
  })
);

const Logo = () => {
  return (
    <RouterLink
      to={HOME_PATH}
      render={({ active: _active, ...linkProps }) => (
        <StyledNavLink>
          <img src={LogoImage} height={40} alt="ChainMail" {...linkProps} />
        </StyledNavLink>
      )}
    />
  );
};

export default Logo;
